module.exports = __webpack_public_path__ + "img/footer-left.a4b6c60f.svg";